import { Form, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
// import { UserInfoContext } from "Context/CommonContext";
import ChannelRichEditor, {
  isRichTextEmpty,
} from "Components/CommonComponents/ChannelRichEditor";

export const POST_TYPES = [{ label: "Post", value: "POST" }];
export const GENERAL_SUBJECT = { label: "General", value: "general" };

const PostDetails = (_props: any) => {
  console.log("PostDetails props:", _props);
  return (
    <>
      <Form.Item
        name="title"
        label={
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            Title
            <Tooltip title="Text only">
              <InfoCircleOutlined
                style={{
                  color: "#8c8c8c",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </span>
        }
        rules={[
          { required: true, message: "Please enter the title!", max: 500 },
        ]}
      >
        <Input maxLength={500} placeholder="Enter title..." />
      </Form.Item>
      <Form.Item
        name="description"
        label="Content"
        rules={[
          {
            validator: (_: any, value: any) => {
              if (isRichTextEmpty(value)) {
                return Promise.reject(new Error("Please enter the content!"));
              }
              if (value && value.length > 5000) {
                return Promise.reject(
                  new Error("Content is too long (max 5000 characters).")
                );
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <ChannelRichEditor placeholder="Write your message here..." />
      </Form.Item>
    </>
  );
};

export default PostDetails;
